export const SideMenuDataAdminLevels = {
  1: {
    name: "Dashboard",
    icon: "fa-solid fa-gauge",
    link: "/",
    AccessCode: "",
    requireStationId: false,
  },
  2: { label: "Fuel Companies & Owners" },
  3: {
    name: "Fuel Station Groups",
    icon: "fa-solid fa-building",
    link: "/fuel_station_Groups/groups_page",
    AccessCode: "VIEW-GROUP",
    requireStationId: false,
  },
  4: {
    name: "Fuel Station Owners",
    icon: "fa-solid fa-user-tie",
    link: "/fuel_station_owners/view",
    AccessCode: "VIEW-COMP",
    requireStationId: false,
  },
  5: { label: "Users And Shifts" },
  6: {
    name: "Company Level User",
    icon: "fa-solid fa-heading",
    link: "/comapny_users/view",
    AccessCode: "VIEW-COMP-USES",
    requireStationId: false,
  },
  7: {
    name: "Roles",
    icon: "fa-solid fa-heading",
    link: "/users/roles",
    AccessCode: "GIVE-PERMISSION",
    requireStationId: false,
  },
  8: {
    name: "Permissions",
    icon: "fa-solid fa-heading",
    link: "/users/permissions",
    AccessCode: "VIEW-PERMISSION",
    requireStationId: false,
  },
};
